module.exports = __webpack_public_path__ + "img/youhuiquan.13bb806c.png";